/**
 * 二维码卡片
 * 对应原 Vue 项目 qrcodeCard.vue
 *
 * 双重用途：
 *   1. Popover 悬浮预览 — 正常渲染在 Popover 里显示给用户看
 *   2. 复制/下载截图 — html2canvas 对根 DOM 节点截图
 *
 * 多实例支持：每个 QrcodeCard 独立 useRef 管 canvas，
 * 不再用 document.getElementById（避免多 Popover 同时渲染时 id 冲突）
 */
import React, { forwardRef, useEffect, useRef } from "react";
import QRious from "qrious";
import qrcodeBg from "@/assets/img/qrcodeBackground.jpg";

const QrcodeCard = forwardRef(({ qrData, initQCode, qrCodeInDate, miceInfo }, ref) => {
  const rootRef = useRef(null);
  const canvasRef = useRef(null);

  // 暴露根 DOM 节点供父组件 html2canvas 截图
  useEffect(() => {
    if (typeof ref === "function") {
      ref(rootRef.current);
    } else if (ref) {
      ref.current = rootRef.current;
    }
  }, [ref]);

  useEffect(() => {
    if (initQCode && canvasRef.current) {
      // eslint-disable-next-line no-new
      new QRious({
        element: canvasRef.current,
        value: initQCode,
        size: 180,
        level: "H",
      });
    }
  }, [initQCode]);

  return (
    <div
      ref={rootRef}
      style={{
        width: 300,
        height: 500,
        backgroundImage: `url(${qrcodeBg})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        color: "#000",
        borderRadius: 4,
        overflow: "hidden",
      }}
    >
      <div style={{ marginTop: 40 }}>
        <canvas ref={canvasRef} />
      </div>
      <div
        style={{
          fontSize: 16,
          fontWeight: 700,
          marginTop: 20,
          textAlign: "center",
        }}
      >
        {miceInfo?.name}
      </div>
      <div style={{ marginTop: 8 }}>
        二维码有效期：
        {qrCodeInDate ? qrCodeInDate.join("~") : ""}
      </div>
    </div>
  );
});

export default QrcodeCard;
